<div aria-live="polite" aria-atomic="true">

  <!-- Position it -->
  <div style="position: fixed; top: 5.5rem; right: 1rem;">
    <div class="toast" id="{{toastID}}" role="alert" aria-live="assertive" aria-atomic="true" data-delay="10000">
      <button aria-label="Cerrar" data-dismiss="toast" type="button" class="close">
        <i class="icon-circle-close"></i>
      </button>
      <div class="toast-body">
        <div class="row">
          <div class="col-1 icon">
            <i [ngClass]=" classIcon ? classIcon: 'icon-check'"></i>
          </div>
          <div class="col-11">
            <span [innerHTML]="innerHTML"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>